import { notification } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { GetNotificationParams, MarkReadParam } from '../types'
const getAllNotification = async ({
    currentPage,
    recordsPerPage,
    unReadNotifications,
}: GetNotificationParams): Promise<any> => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 10,
        pageNumber: currentPage ? currentPage : 1,
        unReadNotifications: unReadNotifications,
    }
    const response = axios.post(notification.GET_NOTIFICATION, data)
    return response
}

const markReadNotificatiopn = async ({
    notificationId,
    isAllMarkAsRead,
}: MarkReadParam): Promise<any> => {
    const data = {
        notificationId,
        isAllMarkAsRead,
    }
    const response = axios.put(notification.READ_NOTIFICATION, data)
    return response
}
export { getAllNotification, markReadNotificatiopn }
